var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('linkedin-share-button');
import { breakpoints } from '@shapeable/theme';
import { IconBubble } from './icon-bubble';
import { LinkedinShareButton as Button } from 'react-share';
import { LinkedinIconGlyph } from '@shapeable/icons';
export var LinkedinShareButtonDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Bubble: styled(IconBubble)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles)
};
export var LinkedinShareButton = function (props) {
  var className = props.className,
    url = props.url,
    title = props.title,
    color = props.color,
    hoverColor = props.hoverColor,
    iconColor = props.iconColor;
  return React.createElement(My.Container, {
    url: url,
    title: title,
    className: cls.name(className)
  }, React.createElement(My.Bubble, {
    color: color,
    hoverColor: hoverColor,
    iconColor: iconColor,
    icon: React.createElement(LinkedinIconGlyph, null)
  }));
};
LinkedinShareButton.defaultProps = LinkedinShareButtonDefaultProps;
LinkedinShareButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;